// This file sets up jsPDF with the autoTable plugin
import {jsPDF} from 'jspdf'

// Import autoTable and apply it to jsPDF
try {
    // Try to import as default export
    const autoTable = require('jspdf-autotable').default

    // Check if autoTable is a function
    if (typeof autoTable === 'function') {
        // Apply autoTable to jsPDF
        autoTable(jsPDF)
    }
} catch (error) {
    // Try alternative import
    try {
        require('jspdf-autotable')
    } catch (altError) {
        // Silent fail - autoTable may not be available
    }
}

// Export the configured jsPDF
export {jsPDF}
